const container = document.getElementById('bundle-container');
const productId = document.querySelector('#bundle-container input[name="product_id"]').value;

const revySubmitButtonObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes?.[0]?.classList?.contains('rbu-mpb-success-icon')) {
      openCartOverlay()
    }
  });
});

const checkIfProductIsInBundle = () => {
  if (window.RevyBundle) {
    const hasBundles = Array.isArray(window.RevyBundle.data.bundles) && window.RevyBundle.data.bundles.length > 0

    if (hasBundles) {
      const bundles = window.RevyBundle.data.bundles

      bundles.forEach(bundle => {
        const productIsInBundle = bundle.bundle_products.find((product) => product.product_id === Number(productId))

        if (productIsInBundle) {
          const newBundleElement = document.createElement('div')
          newBundleElement.setAttribute('data-revy-bundle-id', bundle.bundle.uuid)
          container.appendChild(newBundleElement)

          revySubmitButtonObserver.observe(document.querySelector('#bundle-container'), {
            childList: true,
            subtree: true
          });

          return
        }
      })
    }
  }
}

window.addEventListener('load', () => {
  checkIfProductIsInBundle();
});